<template>
  <div class='component-page'>
    <div class="filter-area">
      <Row class='add_search'>
        <Col span="2">
        <i-button icon="md-add" shape="circle" style='margin-left:10px;' type="primary" @click="add_new">添加</i-button>
        </Col>
        <Col span="5" style="float:right;">
        <Input search v-model="formItem.username" placeholder="输入用户名" @on-search="handleSearch" style="width: 240px;" />
  
        </Col>
  
      </Row>
    </div>
    <div class="edittable-table-height-con">
      <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
      <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
        <Page style='float: right' size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
      </div>
    </div>
  
    <Modal v-model="addEdit" width="520" :title="modelTitle">
      <div v-if='addEdit'>
        <Form ref="formdate" :model="formdate" :rules="ruleValidate" label-position="top">
          <Row>
            <Col span="11" style='margin-right:30px;'>
            <FormItem label="角色" prop='role_id'>
              <Select filterable v-model="formdate.role_id" placeholder="角色" clearable>
                                      <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                                  </Select>
            </FormItem>
            </Col>
            <Col span="11">
            <FormItem label="账号名称" prop='username'>
              <Input v-model="formdate.username" type="text" placeholder="请输入..."></Input>
            </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
            <FormItem label="登录密码" prop='password'>
              <Input v-model="formdate.password" type="text" placeholder="请输入..."></Input>
            </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11" style='margin-right:30px;'>
            <FormItem label="姓名" prop='realname'>
              <Input v-model="formdate.realname" type="text" placeholder="请输入..."></Input>
            </FormItem>
            </Col>
            <Col span="11">
            <FormItem label="手机号" prop='phone'>
              <Input v-model="formdate.phone" type="text" placeholder="请输入..."></Input>
            </FormItem>
            </Col>
          </Row>
  
          <Row>
            <Col span="24">
            <FormItem label="邮箱" prop='email'>
              <Input v-model="formdate.email" type="text" placeholder="请输入..."></Input>
            </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div slot="footer">
        <Button type='primary' shape="circle" ghost @click='cancel'>取消</Button>
        <Button type="primary" shape="circle" @click="add_save('formdate')">保存</Button>
      </div>
    </Modal>
    <Modal v-model="remindModal" width="440" @on-cancel='cancelRemind' class='remind'>
      <div class='remindContent'>
        {{remindContent}}
      </div>
      <div slot="footer">
        <Button type='primary' ghost shape="circle" @click='cancelRemind'>取消</Button>
        <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<style lang="css">
  @import "../common.css";
</style>

<script>
  import {
    fetchTableList,
    fetchRoleList,
    seeModify,
    seeAdd,
    fetchinfo,
    changeStatus
  } from '@/api/adminList'
  
  import moment from 'moment'
  
  export default {
    name: 'user-components',
  
    data() {
      return {
        total_count: 0, // 列表总条数
        editIncellData: [], // 列表数据
        addEdit: false, // 添加/修改的Modal的显隐
        modelTitle: '新增',
        id: '',
        typeList: [],
        remindModal: false,
        remindContent: '',
        ruleValidate: {
          role_id: [{
            required: true,
            message: '角色不能为空'
          }],
          username: [{
            required: true,
            message: '账户名称不能为空',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          }],
          realname: [{
            required: true,
            message: '姓名不能为空',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: '手机号码不能为空',
            trigger: 'blur'
          }],
          email: [{
            required: true,
            message: '邮箱不能为空',
            trigger: 'blur'
          }]
        }, // 添加/修改参数验证
        formItem: {
          page: 1, // 列表当前页数
          page_size: 10,
          username: ''
        }, // 搜索条件
        formdate: {
          id: '',
          role_id: '',
          username: '',
          password: '',
          email: '',
          realname: '',
          phone: ''
        }, // 添加/修改的参数
        editIncellColumns: [{
            title: '序号',
            align: 'center',
            type: 'index',
            width: 80
          },
          {
            title: '角色类型',
            align: 'center',
            key: 'name'
          },
          {
            title: '账号',
            align: 'center',
            key: 'username'
          },
          {
            title: '姓名',
            align: 'center',
            key: 'realname'
          },
  
          {
            title: '手机号',
            align: 'center',
            key: 'phone'
          },
          {
            title: '邮箱',
            align: 'center',
            key: 'email'
          },
          {
            title: '创建时间',
            align: 'center',
            width: 150,
            key: 'create_at',
            render: (h, params) => {
              return h('span', {
  
              }, moment(parseInt(params.row.create_at) * 1000).format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '操作',
            align: 'center',
            key: 'action',
            width: 130,
            align: 'center',
            render: (h, params) => {
              if (params.row.status == 1) {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      ghost: true,
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.edit(params.row.proxy_user_id)
                      }
                    }
                  }, '修改'),
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small',
                      ghost: true,
  
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changeState(params.row.proxy_user_id, '是否冻结此用户', '冻结成功')
                      }
                    }
                  }, '冻结')
                ])
              } else {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      ghost: true,
  
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.edit(params.row.proxy_user_id)
                      }
                    }
                  }, '修改'),
                  h('Button', {
                    props: {
                      type: 'warning',
                      size: 'small',
                      ghost: true,
  
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changeState(params.row.proxy_user_id, '是否解冻此用户', '解冻成功')
                      }
                    }
                  }, '解冻')
                ])
              }
            }
          }
        ] // 列表标题
      }
    },
    methods: {
  
      // 获取列表数据
      getData() {
        this.$Loading.start()
        fetchTableList(this.formItem).then(responese => {
          this.$Loading.finish()
          responese = responese.data;
          if (responese.code == 200) {
            this.editIncellData = responese.data.list
            this.total_count = parseInt(responese.data.total_count)
          } else if (responese.code == 14001) {
            this.$store.dispatch('handleLogOut').then(res => {
              this.$store.commit('clearOpenedSubmenu')
              this.$router.push({
                name: 'login'
              })
            })
            this.$Message.error(responese.msg)
          } else {
            this.$Message.error(responese.msg)
          }
        })
      },
      // 获取角色下拉
      getSelect() {
        fetchRoleList().then(res => {
          res = res.data;
          this.$Loading.finish()
          if (res.code == 200) {
            this.typeList = res.data
          } else if (res.code == 14001) {
            this.$store.dispatch('handleLogOut').then(res => {
              this.$store.commit('clearOpenedSubmenu')
              this.$router.push({
                name: 'login'
              })
            })
            this.$Message.error(res.msg)
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      // 添加
      add_new() {
                this.ruleValidate.password[0].required=true;

        this.modelTitle = '新增'
        this.formdate.id = ''
        this.formdate.role_id = ''
        this.formdate.username = ''
        this.formdate.password = ''
        this.formdate.email = ''
        this.formdate.realname = ''
        this.formdate.phone = ''
        this.addEdit = true
      },
      // 添加保存
      add_save(name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            if (this.formdate.id != '') {
              seeModify({
                id: this.formdate.id,
                role_id: this.formdate.role_id,
                username: this.formdate.username,
                password: this.formdate.password,
                email: this.formdate.email,
                realname: this.formdate.realname,
                phone: this.formdate.phone
              }).then(res => {
                res = res.data;
                if (res.code == 200) {
                  this.addEdit = false
                  this.getData()
                } else if (res.code == 14001) {
                  this.$store.dispatch('handleLogOut').then(res => {
                    this.$store.commit('clearOpenedSubmenu')
                    this.$router.push({
                      name: 'login'
                    })
                  })
                  this.$Message.error(res.msg)
                } else {
                  this.$Message.error(res.msg)
                }
              })
            } else {
              seeAdd({
                role_id: this.formdate.role_id,
                username: this.formdate.username,
                password: this.formdate.password,
                email: this.formdate.email,
                realname: this.formdate.realname,
                phone: this.formdate.phone
              }).then(res => {
                res = res.data;
                if (res.code == 200) {
                  this.addEdit = false
                  this.getData()
                } else if (res.code == 14001) {
                  this.$store.dispatch('handleLogOut').then(res => {
                    this.$store.commit('clearOpenedSubmenu')
                    this.$router.push({
                      name: 'login'
                    })
                  })
                  this.$Message.error(res.msg)
                } else {
                  this.$Message.error(res.msg)
                }
              })
            }
          }
        })
      },
      // 修改
      edit(id) {
                this.ruleValidate.password[0].required=false;

        this.modelTitle = '修改';
        fetchinfo({
          id: id
        }).then(res => {
          res = res.data;
          if (res.code == 200) {
            this.formdate = res.data
            this.formdate.id = id;
            this.addEdit = true
          } else if (res.code == 14001) {
            this.$store.dispatch('handleLogOut').then(res => {
              this.$store.commit('clearOpenedSubmenu')
              this.$router.push({
                name: 'login'
              })
            })
            this.$Message.error(res.msg)
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
  
      // 封禁/解封用户
      changeState(id, info) {
        this.id = id;
        this.remindContent = info;
        this.remindModal = true;
  
      },
      cancelRemind() {
        this.remindModal = false;
      },
      primaryRemind() {
        changeStatus({
            id: this.id
          })
          .then(res => {
            var responese = res.data
            if (responese.code == 200) {
              this.$Message.success('设置成功')
              this.remindModal = false
              this.getData()
            } else if (responese.code == 14001) {
              this.$store.dispatch('handleLogOut').then(res => {
                this.$store.commit('clearOpenedSubmenu')
                this.$router.push({
                  name: 'login'
                })
              })
              this.$Message.error(responese.msg)
            } else {
              this.$Message.error(responese.msg)
            }
          })
      },
      // 取消/返回
      cancel() {
        this.addEdit = false
      },
      handleSearch() {
        this.formItem.page = 1
        this.getData()
      },
      // 改变当前页码
      changePage(row) {
        this.formItem.page = row
        this.getData()
      },
  
    },
    created() {
      this.getSelect();
      this.getData();
    }
  }
</script>
